// extracted by mini-css-extract-plugin
export default {"root":"src__components__action-buttons__escape-button__root","root_withCrossIcon":"src__components__action-buttons__escape-button__root_withCrossIcon"};